// extracted by mini-css-extract-plugin
module.exports = {"AboutWrapper":"aboutMe_AboutWrapper__2nlxL","AboutME":"aboutMe_AboutME__9F1x0","grow":"aboutMe_grow__R530y"};